import i18n from "@/plugins/vue-i18n";
import { fullTextSearch } from "@/api/products";

export default {
  namespaced: true,
  state: {
    status: {
      free: {
        label: i18n.t("product.status.available"),
        color: "green",
        value: "free",
      },
      reserved: {
        label: i18n.t("product.status.reserved"),
        color: "yellow",
        value: "reserved",
      },
      notAvailable: {
        label: i18n.t("product.status.notAvailable"),
        color: "red",
        value: "notAvailable",
      },
      expected: {
        label: i18n.t("product.status.expected"),
        color: "violet",
        value: "expected",
      },
      preOrder: {
        label: i18n.t("product.status.preOrder"),
        color: "blue",
        value: "preOrder",
      },
    },
    cartProducts: [],
    pendingAddToCartNotify: 0,
    /** Product id (last add) while server save is in progress; cleared after saveCart completes */
    addingToCartProductId: null,
    /** True while adding a bundle kit; cleared after saveCart completes */
    isAddingBundleToCart: false,
    searchForm: {
      category: {},
      search: "",
      contract: "",
      name: "",
      status: "",
    },
    filtersForm: {
      name: "",
      status: "",
    },
    currentPaymentMethod: "",
    tags: [
      {
        type: "discount",
        value: i18n.t("product.promotions.discount"),
        color: "red",
        symbol: "%",
      },
      {
        type: "bonus",
        value: i18n.t("product.promotions.bonus"),
        color: "green",
        symbol: "%",
      },
      {
        type: "bundleDiscount",
        value: i18n.t("product.promotions.bundle_discount"),
        color: "orange",
      },
      {
        type: "retroBonusPercent",
        value: i18n.t("product.promotions.retro_bonus"),
        color: "yellow",
        symbol: "%",
      },
      {
        type: "retroBonusAmount",
        value: i18n.t("product.promotions.retro_bonus"),
        color: "yellow",
        symbol: "$",
      },
      {
        type: "wholesalePrices",
        value: i18n.t("product.promotions.wholesalePrices"),
        color: "blue",
      },
      {
        type: "preOrder",
        value: i18n.t("product.status.preOrder"),
        color: "blue",
      },
    ],
  },
  getters: {
    getStatus(state) {
      return (status, date) => {
        if (state.status[status]) {
          if (state.status[status].value === "expected") {
            const { label, color, value } = state.status[status];

            return {
              label: `${label} ${date}`,
              color,
              value,
            };
          }

          return state.status[status];
        }
      };
    },

    getStatuses(state) {
      return Object.values(state.status);
    },

    getCartProducts(state) {
      const { cartProducts } = state;

      cartProducts.forEach((item) => {
        if (!item.quantity) item.quantity = 1;
      });

      return cartProducts;
    },

    getCategories(state) {
      return state.searchForm.category;
    },

    getFilterForm(state) {
      return state.filtersForm;
    },

    getPaymentMethod(state) {
      return state.currentPaymentMethod;
    },

    getTags(state) {
      return state.tags;
    },
  },
  mutations: {
    SET_CART_PRODUCTS(state, cart) {
      state.cartProducts = cart;
    },

    ADD_PRODUCT_TO_CART(state, product) {
      const { cartProducts } = state;
      const index = cartProducts.findIndex((item) => parseInt(item.id) === parseInt(product.id));

      if (parseInt(cartProducts[index]?.id) === parseInt(product.id)) {
        const stateProduct = cartProducts[index];

        stateProduct["quantity"] += product["quantity"];
        // stateProduct["quantity"]++;

        cartProducts.splice(index, 1, stateProduct);
      } else {
        cartProducts.push(product);
      }

      state.pendingAddToCartNotify += 1;

      if (!state.isAddingBundleToCart) {
        state.addingToCartProductId = product.id;
      }
    },

    DELETE_PRODUCT_FROM_CART(state, productId) {
      const { cartProducts } = state;
      const index = cartProducts.findIndex((item) => parseInt(item.id) === parseInt(productId));

      cartProducts.splice(index, 1);

      if (!cartProducts.length) state.cartProducts = [];
    },

    SET_PRODUCT_QUANTITY(state, [productId, newProductQuantity]) {
      const { cartProducts } = state;

      const index = cartProducts.findIndex((item) => parseInt(item.id) === parseInt(productId));
      const product = cartProducts[index];

      product["quantity"] = newProductQuantity;
      cartProducts.splice(index, 1, product);
    },

    SET_CATEGORY(state, category) {
      state.searchForm.category = category;
    },

    SET_SEARCH(state, search) {
      state.searchForm.search = search;
    },

    SET_CONTACT(state, contract) {
      state.searchForm.contract = contract;
    },

    SET_FILTERS_FORM(state, form) {
      state.filtersForm = form;
    },

    SET_PAYMENT_METHOD(state, method) {
      state.currentPaymentMethod = method;
    },

    CLEAR_PENDING_ADD_TO_CART_NOTIFY(state) {
      state.pendingAddToCartNotify = 0;
    },

    SET_ADDING_BUNDLE_TO_CART(state, value) {
      state.isAddingBundleToCart = Boolean(value);
    },

    CLEAR_ADD_TO_CART_LOADING(state) {
      state.addingToCartProductId = null;
      state.isAddingBundleToCart = false;
    },

    CLEAR_CATEGORY(state) {
      state.searchForm.category = {};
    },
  },

  actions: {
    async getProductsDataByFullTextSearch(context, searchData) {
      return { products: await fullTextSearch(searchData) };
    },
  },
};
